import { gql } from '@apollo/client';

export const CANCEL_APPOINTMENT = gql`
  mutation CANCEL_APPOINTMENT($appointmentId: String!) {
    cancelAppointment(appointmentId: $appointmentId)
  }
`;
